import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { addBodyScroll, removeBodyScroll } from '../utils/utils';
const Modal = ({ children, isOpen, onClose, size, closeOnEscape, className, classNameContent, isUpdateBodyScroll = true, isDisabled = false, onSubmit, }) => {
    const [isShowBackdrop, setIsShowBackdrop] = useState(false);
    let [backdrop, setBackdrop] = useState(null);
    useEffect(() => {
        if (isOpen) {
            setIsShowBackdrop(true);
        }
        else {
            setIsShowBackdrop(false);
        }
    }, [isOpen]);
    if (!size) {
        size = 'md';
    }
    const getRef = (ref) => {
        setBackdrop(ref);
    };
    const closeModal = () => {
        if (isUpdateBodyScroll) {
            addBodyScroll();
        }
        onClose();
        document.removeEventListener('keydown', escFunction, false);
    };
    const escFunction = (event) => {
        if (event.keyCode === 27) {
            if (!isDisabled) {
                closeModal();
            }
        }
    };
    useEffect(() => {
        if (isOpen) {
            if (closeOnEscape !== undefined ? closeOnEscape : true) {
                document.addEventListener('keydown', escFunction, false);
            }
            if (isUpdateBodyScroll) {
                removeBodyScroll();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen, closeOnEscape, isUpdateBodyScroll]);
    const onClickContent = (evt) => {
        evt.stopPropagation();
    };
    const onClickBackdrop = (evt) => {
        if (!isDisabled) {
            let path = null;
            if (evt.nativeEvent.path) {
                path = evt.nativeEvent.path[0] || evt.nativeEvent.composedPath;
            }
            else if (evt.nativeEvent.composedPath) {
                path = evt.nativeEvent.composedPath()[0];
            }
            if (path === backdrop) {
                closeModal();
            }
        }
    };
    const onScroll = (evt) => {
        evt.stopPropagation();
    };
    const classNameResult = classNames('ac-modal', { open: isOpen, 'ac-modal-backdrop': isShowBackdrop }, className);
    const classNameContentResult = classNames('ac-modal-content', size, classNameContent);
    let content;
    if (onSubmit) {
        content = (React.createElement("form", { className: classNameContentResult, onClick: onClickContent, onScroll: onScroll, onSubmit: onSubmit }, children));
    }
    else {
        content = (React.createElement("div", { className: classNameContentResult, onClick: onClickContent, onScroll: onScroll }, children));
    }
    return (React.createElement("div", { className: classNameResult, onMouseDown: onClickBackdrop, ref: getRef }, content));
};
export { Modal };
//# sourceMappingURL=Modal.js.map